export default __webpack_public_path__ + "assets/images/40b9a2af26437e57155e6442fe35a1fc-per_app_store.svg";